import React from "react";
import UserLoginsModule from "./UserLoginsModule";
import UserLoginSagas from "./redux/userLoginSagas";
import UserLoginsReducer from "./redux/userLoginsReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Login Report",
  moduleList: [
    {
      Component: UserLoginsModule,
      moduleName: "loginReport",
      saga: UserLoginSagas(),
      reducer: UserLoginsReducer
    }
  ],
  hideConfigurator: true
};

const UserLoginsPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default UserLoginsPage;
